module.exports = __webpack_public_path__ + "img/pcbanner3.e345dbbd.png";